import { PageHeader } from "@design-system/components";
import { BasicInformation } from "../components";
import { investorBasicInfoBreadcrumb } from "../data";

export function InvestorBasicInformationPage() {
  return (
    <>
      <PageHeader
        translationKey="basicInfo.title"
        breadcrumbItems={investorBasicInfoBreadcrumb}
      />

      <BasicInformation />
    </>
  );
}
